import { GOONCHA_LOAD_ERROR } from "../lib/goonchaDeal";

/**
 * Shown under the robot-check row when `/gooncha/new` failed. `role="alert"` so a
 * screen reader hears it when it appears; Retry asks for a NEW challenge, once, and is
 * the only thing that does (nothing retries behind the viewer's back). Retry is a full
 * 44px tap target: it sits under a checkbox on a phone.
 */
export function GoonchaLoadError({ onRetry }: { onRetry: () => void }) {
  return (
    <div role="alert" className="mt-1.5 flex items-center justify-between gap-2 px-1 text-xs text-red-400">
      <span>{GOONCHA_LOAD_ERROR}</span>
      <button
        type="button"
        onClick={onRetry}
        className="inline-flex min-h-[44px] min-w-[64px] shrink-0 items-center justify-center rounded-md px-3 font-semibold text-[var(--color-accent-soft)] hover:bg-[var(--color-panel-2)]"
      >
        Retry
      </button>
    </div>
  );
}
